import { Typography } from "@suraasa/placebo-ui"
import clsx from "clsx"
import React from "react"

const Card = ({
  svg,
  svgBgClassName,
  className,
  title,
  description,
}: {
  svg: React.ReactNode
  svgBgClassName?: string
  className?: string
  title: string
  description: string
}) => {
  return (
    <div
      className={clsx(
        "flex flex-col overflow-hidden rounded-2xl bg-[#F8F9FA]",
        className
      )}
    >
      <div className={clsx("p-2.5", svgBgClassName)}>{svg}</div>
      <div className="px-3 pb-2.5">
        <Typography variant="strongSmallBody" className="mb-1.5">
          {title}
        </Typography>
        <Typography variant="smallBody" className="text-onSurface-600">
          {description}
        </Typography>
      </div>
    </div>
  )
}

export default Card
